<template>
  <a-modal :visible="visible.batchDeleteRaw" :bodyStyle="{ padding: '10px' }" :destroyOnClose="true" :forceRender="true"
    okText="确定删除" @ok="ok" @cancel="toggleVisible('batchDeleteRaw')" width="900px">
    <span class="title" slot="title">批量删除原料<b>在选中的配方中删除原料</b></span>
    <div class="raw-model-info-row">已选中配方：
      <span>{{ formulaSelectedRows.map(item => `【${item.formulaName}】`).join(',') }}</span>
    </div>
    <div class="raw-model-info-row">可删除原料明细：</div>
    <a-spin :spinning="delLoading" tip="原料删除中">
      <a-space style="padding:0 0 10px">
        <a-input-search size="small" v-model="filterData.keyword" @change="e => inputChange(e, 'keyword')"
          placeholder="原料名称/代码" style="width: 180px" @search="e => onSearch(e, 'keyword')" />
        <a-input-search v-if="overseasFlag == 1" size="small" v-model="filterData.aliasName"
          @change="e => inputChange(e, 'aliasName')" placeholder="原料别名" style="width: 180px"
          @search="e => onSearch(e, 'aliasName')" />
        <base-list-select style="width:220px" :value="rawType" @change="typeChange" placeholder="选择原料类型"
          category="raw" />
      </a-space>
      <a-table :columns="columns" bordered :scroll="{ x: 870, y: 450 }"
        :row-selection="{ selectedRowKeys, onChange: onSelectChange }" :loading="nutLoading" :data-source="list"
        :row-key="record => record.rawId" :pagination="false">
        <template slot="rawName" slot-scope="text,record">
          {{ overseasFlag == '1' ? (record.aliasName || text) : text }}
        </template>
        <template slot="rawTypeName" slot-scope="text, record, index">
          <a-tooltip @visibleChange="rawTypeNameTipsVisibleChange($event, record, index)">
            <template slot="title">
              {{ record.fullTypeName }}
            </template>
            <span style="cursor: pointer" :style="{ color: record.color }">{{ text }}</span>
          </a-tooltip>
        </template>
      </a-table>
    </a-spin>
  </a-modal>
</template>
<script>
import BaseListSelect from '../../Nhf/Compound/select/BaseListSelect.vue';
import { formulaMixins } from '../unitls';
export default {
  components: { BaseListSelect },
  props: ['hidden'],
  mixins: [formulaMixins],
  data() {
    return {
      overseasFlag: window.localStorage.getItem('overseasFlag'),
      nutLoading: false,
      delLoading: false,
      filterData: {},
      list: [],
      rawType: [],
      addLoading: false,
      columns: [
        {
          dataIndex: 'rawName',
          title: '原料名称',
          width: '160',
          scopedSlots: { customRender: 'rawName' },
        },
        {
          dataIndex: 'rawCode',
          align: 'center',
          title: '代码',
          width: 100
        },
        {
          dataIndex: 'typeName',
          title: '类型',
          width: 180,
          scopedSlots: { customRender: 'rawTypeName' },
        },
        {
          dataIndex: 'storageWeight',
          align: 'center',
          title: '库存量(Ton)',
          width: 80
        }
      ]
    };
  },

  watch: {
    'visible.batchDeleteRaw'(val) {
      val ? this.getList() : this.restList();
    }
  },

  methods: {
    inputChange({ target }, field) {
      this.getList({
        [field]: target.value
      });
    },
    onSearch(name, field) {
      this.getList({
        [field]: name
      });
    },
    async batchDeleteRaw() {
      return this.fetchPost({
        actions: this.batchDelFormulaRaw,
        loading: 'delLoading',
        data: {
          rawIds: this.selectedRows.map(i => i.rawId).join(),
          taskFormulaIds: this.formulaSelectedRows.map(i => i.id).join(),
          taskId: this.taskId
        }
      });
    },

    async ok() {
      if (this.selectedRows.length) {
        await this.batchDeleteRaw();
        this.toggleVisible('batchDeleteRaw');
        this.$emit('ok');
        this.$emit('refresh');
      } else {
        this.$message.warn('选择需要删除的原料');
      }
    },

    getList(arg = {}) {
      return this.fetchGet({
        actions: this.selectReplaceTaskFormulaRaw,
        name: 'list',
        loading: 'nutLoading',
        data: {
          taskFormulaIds: this.formulaSelectedRows.map(i => i.id).join(),
          ...arg,
          factoryId: this.factoryId,
          size: 2000
        }
      });
    },

    restList() {
      this.filterData = {};
      this.rawType = [];
      this.cleanSelect();
    },

    typeChange(val) {
      this.rawType = val;
      const typeId = [...val].pop();
      this.filterData.typeId = typeId;
      this.getList({
        typeId
      });
    },

    rawTypeNameTipsVisibleChange(show, item) {
      item.color = show ? '#1677FF' : '';
      this.$forceUpdate();
    },
  }
};
</script>
<style lang="scss" scoped>
.title {
  display: flex;
  align-items: center;

  b {
    font-size: 12px;
    font-weight: normal;
    color: #999;
    margin-left: 10px;
  }
}

.raw-model-info-row {
  margin-bottom: 8px;

  span {
    color: #999;
  }
}
</style>
